module.exports = "https://web-assets.ifttt.com/packs/media/docs/triggerrssfeed-b58a6798.gif";